export function classNames(...args) {
  const classes = [];
  args.forEach((arg) => {
    if (Array.isArray(arg))
      classes.push(classNames(...arg));
    else if (typeof arg === "object" && !Array.isArray(arg)) {
      for (let key in arg) {
        if (arg[key])
          classes.push(key);
      }
    } else if (typeof arg === "string")
      classes.push(arg);
  });
  const classesNoEmpty = classes.filter((c) => typeof c === "string" && c.length);
  return classesNoEmpty.join(" ").trim();
}
export function getCSSValuesForLogicalAttribute(attribute, serializer = (x) => x?.toString()) {
  if (attribute.inline || attribute.block) {
    const inlineValue = serializer(attribute.inline);
    const blockValue = serializer(attribute.block);
    return {
      inlineStart: inlineValue,
      inlineEnd: inlineValue,
      blockStart: blockValue,
      blockEnd: blockValue
    };
  }
  if (attribute.inlineStart || attribute.inlineEnd || attribute.blockStart || attribute.blockEnd) {
    return {
      inlineStart: serializer(attribute.inlineStart),
      inlineEnd: serializer(attribute.inlineEnd),
      blockStart: serializer(attribute.blockStart),
      blockEnd: serializer(attribute.blockEnd)
    };
  }
  const singleValue = serializer(attribute);
  return {
    inlineStart: singleValue,
    inlineEnd: singleValue,
    blockStart: singleValue,
    blockEnd: singleValue
  };
}
function isNullish(value) {
  return value === void 0 || value === null;
}
export function getClassNamesForLogicalAttribute(attribute, prefix = "", serializer = (x) => x?.toString()) {
  if (!attribute) {
    return [];
  }
  const cssValues = getCSSValuesForLogicalAttribute(attribute, serializer);
  const classNames2 = [];
  if (!isNullish(cssValues.inlineStart)) {
    classNames2.push(`${prefix ? prefix + "-" : ""}inline-start-${cssValues.inlineStart}`);
  }
  if (!isNullish(cssValues.inlineEnd)) {
    classNames2.push(`${prefix ? prefix + "-" : ""}inline-end-${cssValues.inlineEnd}`);
  }
  if (!isNullish(cssValues.blockStart)) {
    classNames2.push(`${prefix ? prefix + "-" : ""}block-start-${cssValues.blockStart}`);
  }
  if (!isNullish(cssValues.blockEnd)) {
    classNames2.push(`${prefix ? prefix + "-" : ""}block-end-${cssValues.blockEnd}`);
  }
  return classNames2;
}
